module.exports = __webpack_public_path__ + "0272fce19ecd3acb9580b5f4f0ee3043.svg";